import React, { useState, useEffect } from "react";

import TopLinks from "./top-links/TopLinks";
import NavBar from "./nav-bar/NavBar";

function Header(props) {
  return (
    <header className="flex flex-col-reverse xl:flex-col">
      <TopLinks isSearchToggled={props.isSearchToggled} isHamburgerToggled={props.isHamburgerToggled }/>
      <NavBar isSearchToggled={props.isSearchToggled} isHamburgerToggled={props.isHamburgerToggled} clickSearch={props.clickSearch} clickHamburger={props.clickHamburger}/>
    </header>
  );
}

export default Header;
